<script>
import { mapGetters } from 'vuex'

export default {
    name: process.env.VUE_APP_NAME,

    computed: {
        ...mapGetters(['timezone', 'mobileDevice']),
    },

    created() {
        this.$moment.tz.setDefault(this.timezone)
    },

    methods: {
        preventZoom(e) {
            if (this.mobileDevice && !['BUTTON', 'A'].includes(e.target.tagName)) {
                // eslint-disable-next-line no-console
                if (process.env.NODE_ENV === 'development') console.warn('PreventZoom', e)
                e.preventDefault()
            }
        },
    },
}
</script>
<template lang="pug">
#app(@click="preventZoom")
    transition(name="fade")
        router-view
</template>
